<template>
  <b-navbar type="is-dark" class="fondo app-navbar" v-if="usuario">
    <template #brand>
      <b-navbar-item tag="router-link" :to="{ path: '/' }" class="brand-item">
        <span class="brand-icon"><b-icon icon="storefront" size="is-small" /></span>
        <span class="brand-name">SysVentas</span>
      </b-navbar-item>
    </template>

    <template #start>
      <b-navbar-item tag="router-link" :to="{ path: '/' }">
        <b-icon icon="view-dashboard-outline" size="is-small" />
        <span>Inicio</span>
      </b-navbar-item>

      <b-navbar-item tag="router-link" :to="{ path: '/inventario' }" v-if="permisos && permisos['vistas.inventario']">
        <b-icon icon="package-variant" size="is-small" />
        <span>Inventario</span>
      </b-navbar-item>

      <b-navbar-item tag="router-link" :to="{ path: '/marcas-y-categorias' }" v-if="permisos && permisos['vistas.marcas_categorias']">
        <b-icon icon="tag-multiple" size="is-small" />
        <span>Marcas y categorías</span>
      </b-navbar-item>

      <b-navbar-item tag="router-link" :to="{ path: '/realizar-venta' }" v-if="permisos && permisos['vistas.vender']" class="vender-item">
        <b-icon icon="cash-fast" size="is-small" />
        <span>Vender</span>
      </b-navbar-item>

      <b-navbar-item v-if="reportes" class="dropdown-item-nav">
        <b-icon icon="chart-box-outline" size="is-small" class="is-pulled-left" />
        <b-navbar-dropdown label="Reportes">
          <b-navbar-item tag="router-link" :to="{ path: '/reporte-ventas' }"       v-if="permisos && permisos['vistas.ventas']"><b-icon icon="cash-register" /><span>Ventas</span></b-navbar-item>
          <b-navbar-item tag="router-link" :to="{ path: '/reporte-cuentas' }"      v-if="permisos && permisos['vistas.cuentas']"><b-icon icon="wallet" /><span>Cuentas</span></b-navbar-item>
          <b-navbar-item tag="router-link" :to="{ path: '/reporte-apartados' }"    v-if="permisos && permisos['vistas.apartados']"><b-icon icon="wallet-travel" /><span>Apartados</span></b-navbar-item>
          <b-navbar-item tag="router-link" :to="{ path: '/reporte-cotizaciones' }" v-if="permisos && permisos['vistas.cotizaciones']"><b-icon icon="ticket-outline" /><span>Cotizaciones</span></b-navbar-item>
          <b-navbar-item tag="router-link" :to="{ path: '/deliveries' }"           v-if="permisos && permisos['vistas.deliveries']"><b-icon icon="truck-delivery" /><span>Deliveries</span></b-navbar-item>
          <b-navbar-item tag="router-link" :to="{ path: '/choferes' }"             v-if="permisos && permisos['vistas.choferes']"><b-icon icon="card-account-details" /><span>Choferes</span></b-navbar-item>
          <b-navbar-item tag="router-link" :to="{ path: '/historial' }"            v-if="permisos && permisos['vistas.historial']"><b-icon icon="clipboard-text-clock" /><span>Movimientos</span></b-navbar-item>
          <b-navbar-item tag="router-link" :to="{ path: '/proveedores' }"          v-if="permisos && permisos['vistas.proveedores']"><b-icon icon="factory" /><span>Proveedores</span></b-navbar-item>
        </b-navbar-dropdown>
      </b-navbar-item>

      <b-navbar-item tag="router-link" :to="{ path: '/clientes' }" v-if="permisos['vistas.clientes']">
        <b-icon icon="account-group" size="is-small" />
        <span>Clientes</span>
      </b-navbar-item>
    </template>

    <template #end>
      <b-navbar-item v-if="configuracion">
        <b-icon icon="cog-outline" size="is-small" class="is-pulled-left" />
        <b-navbar-dropdown label="Configurar">
          <b-navbar-item tag="router-link" :to="{ path: '/metodos' }"  v-if="permisos && permisos['vistas.metodos']"><b-icon icon="credit-card-outline" /><span>Métodos de pago</span></b-navbar-item>
          <b-navbar-item tag="router-link" :to="{ path: '/usuarios' }" v-if="permisos && permisos['vistas.usuarios']"><b-icon icon="account-cog" /><span>Usuarios</span></b-navbar-item>
          <b-navbar-item tag="router-link" :to="{ path: '/roles' }"    v-if="permisos && permisos['vistas.roles']"><b-icon icon="shield-account" /><span>Roles</span></b-navbar-item>
        </b-navbar-dropdown>
      </b-navbar-item>

      <!-- Toggle modo claro/oscuro -->
      <b-navbar-item>
        <button class="theme-toggle-btn" @click="$emit('cambiar-tema')" :title="tema === 'dark' ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'">
          <b-icon :icon="tema === 'dark' ? 'weather-sunny' : 'weather-night'" size="is-small" />
          <span>{{ tema === 'dark' ? 'Claro' : 'Oscuro' }}</span>
        </button>
      </b-navbar-item>

      <b-navbar-item tag="router-link" :to="{ path: '/perfil' }" class="user-item">
        <span class="user-avatar">{{ iniciales }}</span>
        <span>{{ usuario.usuario }}</span>
      </b-navbar-item>

      <b-navbar-item>
        <a class="button is-light logout-btn" @click="salir">
          <b-icon icon="logout" size="is-small" />
          <span>Salir</span>
        </a>
      </b-navbar-item>
    </template>
  </b-navbar>
</template>

<script>
import HttpService from "@/Servicios/HttpService";

export default {
  name: "EncabezadoComponent",
  props: ["usuario", "permisos", "tema"],
  emits: ["cierre", "cambiar-tema"],

  computed: {
    iniciales() {
      if (!this.usuario?.usuario) return '?'
      return this.usuario.usuario.trim().slice(0, 2).toUpperCase()
    },
    configuracion() {
      if (!this.permisos) return false
      return ["metodos", "usuarios", "roles"].some(c => this.permisos[`vistas.${c}`])
    },
    reportes() {
      if (!this.permisos) return false
      return ["ventas","cuentas","apartados","cotizaciones","deliveries","choferes","historial","proveedores"]
        .some(r => this.permisos[`vistas.${r}`])
    },
  },

  methods: {
    async salir() {
      await HttpService.obtenerConConsultas("usuarios.php", { accion: "cerrar_sesion" })
      this.$emit("cierre")
    },
  },
}
</script>

<style scoped>
.app-navbar { position: sticky; top: 0; z-index: 100; }

.brand-item { display: flex; align-items: center; gap: 7px; padding: 0 0.65rem !important; }
.brand-icon {
   display: flex; align-items: center; justify-content: center;
   width: 28px; height: 28px;
   background: var(--color-primary-transparent-12);
   border: 1px solid var(--color-primary-transparent-25);
   border-radius: var(--radius-sm);
   color: var(--color-primary); flex-shrink: 0;
 }
.brand-name { font-weight: 700; font-size: 0.9rem; color: var(--color-text); letter-spacing: -0.01em; }
.vender-item { color: #14b8a6 !important; }
.user-item { display: flex; align-items: center; gap: 7px; }
.user-avatar {
  display: inline-flex; align-items: center; justify-content: center;
  width: 26px; height: 26px;
  background: rgba(20,184,166,.18);
  border: 1px solid rgba(20,184,166,.3);
  border-radius: 50%;
  font-size: 0.68rem; font-weight: 700; color: #14b8a6; flex-shrink: 0;
}
.logout-btn { display: flex; align-items: center; gap: 5px; }
</style>
